import { defineSlotRecipe } from '@chakra-ui/react';
import { Colors, FontWeights, Radii, Shadows, Space, TextStyles } from '../../types';

export const breadcrumbSlotRecipe = defineSlotRecipe({
  slots: ['root', 'list', 'item', 'link', 'currentLink', 'separator', 'ellipsis'],
  base: {
    list: {
      display: 'flex',
      alignItems: 'center',
      listStyle: 'none',
    },
    item: {
      display: 'inline-flex',
      alignItems: 'center',
    },
    link: {
      display: 'inline-flex',
      gap: Space.SPACE_1,
      fontWeight: FontWeights.NORMAL,
      '&[aria-current=page]': {
        textDecoration: 'none',
        textDecorationColor: 'transparent',
        color: Colors.TEXT_EMPHASIS,
        fontWeight: FontWeights.MEDIUM,
      },
      '&:not([aria-current=page])': {
        _hover: {
          color: Colors.TEXT_EMPHASIS,
          textDecoration: 'underline',
          textDecorationThickness: '1px',
          textUnderlineOffset: '3px',
          textDecorationColor: 'color-mix(in srgb, currentColor 72%, transparent)',
        },
        _focusVisible: {
          boxShadow: Shadows.OUTLINE,
          rounded: Radii.BASE,
        },
      },
    },
    separator: {
      color: Colors.ICON_DEFAULT,
      mx: Space.SPACE_1,
      '&:has(svg)': {
        fontSize: '.75em',
        alignSelf: 'baseline',
      },
    },
  },
  variants: {
    // The current crumb is the `currentLink` slot, which `link`'s aria-current rule never reaches, and stock's
    // default `plain` variant colors it over base; so the emphasis goes in `plain` (partial objects merge).
    variant: {
      plain: {
        currentLink: {
          textDecoration: 'none',
          textDecorationColor: Colors.TRANSPARENT,
          color: Colors.TEXT_EMPHASIS,
          fontWeight: FontWeights.MEDIUM,
        },
      },
    },
    // Stock's default `size: md` sets its own list textStyle, and a variant beats base.
    size: {
      md: {
        list: {
          textStyle: TextStyles.UI_DEFAULT,
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
